<template>
  <v-container>
    <btn-a
      class="ma-2"
      outlined
      rounded
      color="primary"
      @click="itemDialogOpen"
    >
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
    <v-list two-line subheader v-if="value.jobStageItemConss" loading>
      <div v-for="(item, i) in value.jobStageItemConss" :key="i">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ getDescItem(item) }}</v-list-item-title>
            <v-list-item-subtitle
              >{{ $t("entities.jobStageItemCons.props.qtEstimated") }}:
              {{ item.qtEstimated }} |
              {{ $t("entities.jobStageItemCons.props.qtReal") }}:
              {{ item.qtReal }}</v-list-item-subtitle
            >
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="itemDialogOpen(item)">
              <v-icon color="warning">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn icon @click="itemRemove(item)">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider
          v-if="value.item && value.jobStageItemConss.length > 0"
        ></v-divider>
      </div>
    </v-list>
    <dialog-d
      ref="itemDialog"
      title="item"
      @confirm="itemConfirm"
      @cancel="itemDialogCancel"
    >
      <jobStageItemConsForm ref="form" v-model="selectedItem" />
    </dialog-d>
  </v-container>
</template>


<script>
import jobStageItemConsForm from "./jobStageItemConsForm";
export default {
  components: { jobStageItemConsForm },
  props: {
    value: {
      default: () => {
        return {
          jobStageItemConss: []
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      selectedItem: {},
      selectedItemRef: null
    };
  },

  watch: {
    async value() {
      await this.getItemsByIds();
    }
  },
  methods: {
    async getItemsByIds() {
      if (this.value.jobStageItemConss.length == 0) return;
      this.loading = true;
      let itemIds = [];
      this.value.jobStageItemConss
        .filter(i => i.itemId)
        .forEach(i => itemIds.push(i.itemId));
      if (itemIds.length == 0) return;
      let res = await this.$http.get("item/s-ids?ids=" + itemIds.toString());
      if (res.success) this.items = res.data;
      this.loading = false;
    },
    getDescItem(value) {
          let item = this.items != null ? this.items.filter(i => i.id == value.itemId)[0] : null;
      return item ? item.description : value.itemDescription;
    },
    itemDialogCancel() {
      this.selectedItemRef = null;
    },
    async itemConfirm() {
      console.log("ref?", this.$refs);
      console.log("itemConfirmRef", this.selectedItemRef);
      console.log("itemSelected", this.selectedItem);
      console.log("this.value.jobStageItemConss", this.value.jobStageItemConss);

      if (!this.$refs.form.isValid()) return;
      if (this.selectedItemRef) {
        Object.assign(this.selectedItemRef, this.selectedItem);
      } else {
        this.value.jobStageItemConss.push(this.selectedItem);
      }
      for (let items in this.selectedItem){
        if ( isNaN(this.selectedItem[items]) && this.selectedItem[items].includes(',')){
           this.selectedItem[items] = this.selectedItem[items].replace(',' , '.');
        }
      }
      this.$refs.itemDialog.open();
      this.selectedItemRef = null;
      await this.getItemsByIds();
    },
    async itemRemove(item) {
         if(!(await this.$confirm())) return;
      let index = this.value.jobStageItemConss.indexOf(item);
      if (index >= 0) this.value.jobStageItemConss.splice(index, 1);
    },
    itemDialogOpen(item) {
      if (item) {
        this.selectedItemRef = item;
        let obj = {};
        Object.assign(obj, item);
        this.selectedItem = obj;
      } else {
        this.selectedItem = {};
      }

      this.$refs.itemDialog.open();
    }
  },
  created() {
    if (!this.value.jobStageItemConss) this.value.jobStageItemConss = [];
  },
  async mounted() {
    if (!this.value.jobStageItemConss) this.value.jobStageItemConss = [];
    await await this.getItemsByIds();
  }
};
</script>